import * as catalogos from './catalogos/tr';
export const locale = {
  lang: 'tr',
  data: {
    'RESPONDE': catalogos.answer,
    'CONSULTATABLA': {
      'TITULO': 'Şirket verisi',
      'HEADER': 'Şirketler',
      'BUSCAR': 'Ara...',
      'EMPRESA': 'Şirket',
      'MESSAGE3':'<span> Ürünü mantıklı bir şekilde silmek istediğinizden eminseniz, metni metin kutusuna kırmızı ile girin:',
      'MESSAGE4':'</span>',
      'CANCELAR': 'İptal',
      'COMFIR': 'Teyit etmek',
      'PROC_DELE_PROD':'ürün ortadan kaldırmak',
      'SUCC_DELE_PROD':'Ürün başarıyla kaldırıldı',
      'DELE_PRODU':'Ürünü sil',
      'TEX_VERS_RESULT_OPC1':'Varsayılan sürüm',
      'TEX_VERS_RESULT_OPC2':'Özel sürüm',
      'TEX_VERS_RESULT_LAB':'Özel sürüm',
      'TEX_PLAC_RESULT_LAB':'Özel sürümü girin',
      'TEX_MOD_RESULT_VERS':'Sonuç sürümü türünü girmeniz gerekiyor',
      'ACCION': 'İşlem',
      'CREAT_DATE_EMP':'Oluşturma tarihi',
       'TYP_REGISTR_EMP':'Kayıt türü',
       'AUTOR_EMP':'Yazar',
      'SELECT_PLANTILLA': 'Anket şablonu seç',
      'SELECT_EMAIL_PLANTILLA': 'E-mail şablonu seç',
      'DETALLE': 'Ürün',
      'MANAGER_TI': 'IT Yöneticisi',
      'STATUS':'Anket durumu',
      'EMA_HISTO':'Posta Geçmişi',
      'LABEL1': 'Şirket verisi',
      'DESCDETAIL': 'Açısal reaktif formlar, UI olmayan bir veri modeli (tipik olarak bir sunucudan alınan) ile ekrandaki HTML kontrollerinin durumlarını ve değerlerini koruyan UI odaklı bir form modeli arasında akan yüzü gösterir. Reaktif formlar, reaktif kalıpları kullanma, test etme ve doğrulama kolaylığı sunar.  ',
      'DETAIL': 'Detaylar',
      'SECTOR': 'Sektör',
      'SUBSECTOR': 'Alt-sektör',
      'RANKING': 'Sıralama',
      'TIPO': 'Type',
      '0': 'White Icon Design',
      '1': 'Yellow Icon Design',
      '4': 'Simge Tasarım Çemberleri',
      'Reactivos': 'Sorular',
      'NPS': 'Genel algı sorusu',
      'Demograficos': 'Demografi soruları',
      'Forall': 'For All',
      'Adicionales': 'Ek sorular',
      'Control': 'Kontrol sorusu',
      'Abiertas': 'Açık sorular',

      'SELECCIONE_FECHA': 'Tarih',
      'SELECT_CSSID': 'Başvuru yılı',
      'SELECT_CSSIDR': 'Sıralama yılı',
      'TIPORANKING': 'Sıralama türü ',
      'TIP_PRODU': 'Ürün tipi',
      'TIP_PLAN_PRO': 'Şablon adı',
      'TIP_DIS_PRO': 'Tasarım',
      'SELECT_CSSID2': 'Anket tasarımı seç',
      'SURVEYTK_TITU': 'Anket jetonu',
      'SURVEYTK_DESC': 'Bu ürün için Anket Simgesini girin',
      'TABLEAUVER_TITU': 'Sonuç sürümü',
      'TABLEAUVER_DESC': 'Bu ürün için sonuç sistemi sürümünü girin',
      'IDOPORTUNITY': 'Fırsat Kimliği (Sales Force)',
      'NAMEOPORTUNITY': 'fırsat adı (Sales Force)',
      'IDTYPERESULT': 'sonuç türleri',
      'NAM_USE_SWIFT':'Kullanıcı adı',
      'TO_USE_SWIFT':'Toplam ortak çalışan sayısı',
      'EMA_USE_SWIFT':'E-posta kullan',
      'PASS_USE_SWIFT':'Kullanıcı şifresi',
       'CAT_RES':{
         '1':'Tam sonuçlar',
         '2':'Temel sonuçlar',
       },
      'PROYECTMANAGER': 'Proje Müdürü',
      'PROYECTMANAGER_MAIL': 'Proje yöneticisi e-postası',
      'CONFIGURE': 'Ürünleri düzenlemek için tıklayın',
      'INFOR': 'bilgi',
      'ADDPRODUCTS': 'Ürün ekle',
      'ADD': 'Ekle',
      'NAME_SURVEY':'Anket adı:',
      'UPDATE_NAME_SURVEY':'İsmin güncellenmesi',
      'LABELCONTRATADOS': 'Kulanımdaki ürünler',
      'PRODUCTOS': catalogos.productos,
      'PRODUCTOSTURQUIA': catalogos.productosTurquia,
      'CATEGORIAS': catalogos.categorias,
      'GETLISTAEMP': 'Kayıtlı firma listesi yükleniyor',
      'EDITAR': 'Şirket bilgilerini düzenleme',
      'LOGIN': 'Oturum aç',
      'PAGINATOR_1': '',
      'PAGINATOR_2': 'şirket',
      'ELIMINAR': 'Şirketi sil',
      'TIMELINE': 'teknik gereksinimler zaman çizelgesi',
      'CORREOMODIF': 'Bu üründe e-posta gövdesi değişiklikleri var',
      'CORREOMODIFMODAL': 'Bir veya daha fazla üründe doğrulama yapılmasını bekleyen yeni e-posta değişiklikleri var. Lütfen kontrol edin',
      'CORREOMODAL_2': 'Yeni e-posta değişiklikleri şu anda doğrulamayı bekliyor',
      'MODIFBTN': 'Ürün ayarları',
      'INF_BTN': 'Ürün bilgileri',
      'INF_PROD_SEL': 'Ürün bilgileri',
      'VALIDMAIL_1': 'Değişiklikleri doğrula',
      'VALIDMAIL_2': 'Doğrulanmış e-posta',
      'VALIDMAIL_3': 'İletide yapılan değişiklikleri doğrulamak istiyor musunuz?',
      'VALIDMAIL_4': 'E-postadaki değişiklikler doğru bir şekilde doğrulandı',
      'VALIDMAIL_5': 'Değişiklikleri reddet',
      'VALIDMAIL_6': 'Mesajda yapılan değişiklikleri reddetmek ister misiniz?',
      'VALIDMAIL_7': 'E-posta gövdesinde yapılan değişiklikler reddedildi. Bunun yerine varsayılan e-posta şablonu kullanılacak',
      'VALIDMAIL_8': 'Reddedilen e-posta',
      'VALIDMAIL_9': 'Şirkette düzenlemeyi etkinleştir',
      'VALIDMAIL_10': 'Şirkete e-posta düzenlemeyi tekrar etkinleştirmek istiyor musunuz?',
      'VALIDMAIL_11': 'Sürüm şirket için etkinleştirildi',
      'VALIDMAIL_12': 'Postayı düzenle',
      'VALIDMAIL_13': 'Artık şirket tarafından gönderilen e-postayı düzenleyebilirsiniz',
      'SINCORREOS': 'Doğrulanacak e-posta yok',
      'FILEMANODS': 'Dosya yöneticisi',
      'TEX-MENS-1':'Şirket',
      'TEX-MENS-2':'kullanıcı yok',
      'FILEMAN_PRIV': 'Özel klasör',
      'FILEMAN_PUB': 'Genel klasör',
      'USUARIO':'Kullanıcı',
      'AL':'Kullanıcı',
      'SEN_EMAIL_REQ': 'Teknik gereksinimler e-postasını göndermek ister misiniz',
      'SEN_EMAIL_REQ_PROD':' Teknik gereksinimler e-postasını gönderdiğinizden emin olun ',
      'ETIQUE_SEN_EMAIL_REQ_PROD':' Teknik Gereksinimleri Gönderme ',
      'EMAIL_REQ_PLACE': 'Bir dil seçin',
      'EMAIL_REQ_INTRO':'Lütfen devam etmek için bir dil seçin',
      'WARN_SEN_EMAIL_REQ_PROD': 'Devam etmek için bir dil seçmelisiniz',
      'TOOLTI_SEN_EMA':' Posta gönder ',
      'ESTA_EMA_TRUE':' * Gönderilmiş Postalar ',
      'ESTA_EMA_FALSE':' * Posta gönderilmedi ',
      'SEN_EMAIL_MODAL': 'E-posta gönderiliyor ......',
      'RTINFO': 'Teknik gereksinim bilgileri',
      'TOOTI_RES_EMPR':'Etkileyici sonuçlar',
      'WARNI_SELCT_CHECK':'Aramaya devam etmek için en az bir kutucuğun işaretlenmesi zorunludur.',
      'REQ':{
        'BTNSI':'Evet',
        'BTNNO':'Değil',
        'MENSAJE1':'Teknik gereksinimleri devre dışı bırakmak istiyor musunuz?',
        'MENSAJE2':'Teknik gereksinimleri etkinleştirmek istiyor musunuz?',
      },
      'EDITORMAILODS': {
        'OPCION_1': 'Bu ürün için e-posta düzenleyiciyi etkinleştir',
        'OPCION_2': 'Değişikliklerin otomatik olarak doğrulanması',
        'OPCION_3': 'Anket sürecindeki gereksinim ayrıntılarını etkinleştirin',
        'OPCION_4': 'Odak Alanı için anket doğrulamasını etkinleştirin',
        'OPCION_5': 'Uygulama zamanını değiştirmeye izin ver',
        'OPCION_6': 'Uzantılara izin ver',
        'OPCION_7':'Anket süreciyle ilgili gereksinim ayrıntılarında başarılı olma şansı',
        'OPCION_8': 'Atanabilir hatırlatıcı sayısı',
        'OPCION_9': 'Kapanış tarihi baskısını etkinleştir',
        'OPCION_11_ENTREGABLES': 'Çıktıların sonuçlarını Sayım Portalında göster',
        'OPCION_11_RANKING': 'Sayım Portalında sertifika sonuçlarını ve sıralamayı göster',
        'OPCION_12':"Kullanıcı PIN'leriyle anket korumasını etkinleştirin",
        'OPCION_13':'Rastgele doğrulama sorusunu etkinleştirin',
        'OPCION_14': 'Anket Uygulamasında Talimat Kutusunu Göster',
        'OPCION_15': 'Anket Uygulamasında Destek Kutusunu Göster',
        'OPCION_16': 'Anket Uygulamasında Kullanıcı Adını Göster',
        'MODAL_OP1_ON': 'Bu ürün için e-posta düzenleyici etkinleştirildi',
        'MODAL_OP1_OFF': 'Bu ürün için e-posta düzenleyici devre dışı bırakıldı',
        'MODAL_OP2_ON': 'Bu ürün için otomatik değişiklik doğrulaması etkinleştirildi',
        'MODAL_OP2_OFF': 'Bu ürün için otomatik değişiklik doğrulama devre dışı bırakıldı',
        'MODAL_OP6_ON': 'Bu ürün için rolloverlara izin verme etkinleştirildi',
        'MODAL_OP6_OFF': 'Bu ürün için rollover lara izin verme devre dışı bırakıldı',
        'MODAL_OP7_ON': 'Bu ürün için atanabilir hatırlatıcı sayısı değiştirildi',
        'MODAL_OP8_ON': 'Bu ürün için anket kapanış tarihinin düzenlenmesi etkinleştirildi',
        'MODAL_OP8_OFF': 'Bu ürün için anket kapanış tarihini düzenleme devre dışı bırakıldı',
        'MODAL_OP11_ENTREGABLES_ON': 'Teslim edilebilir sonuçların örneği etkinleştirildi',
        'MODAL_OP11_ENTREGABLES_OFF': 'Teslim edilebilir sonuçların örneği devre dışı bırakıldı',
        'MODAL_OP11_RANKING_ON': 'Sertifika ve sıralama sonuçları örneği etkinleştirildi',
        'MODAL_OP11_RANKING_OFF': 'Sertifika ve sıralama sonuçları örneği devre dışı bırakıldı',
        'MODAL_PIN_ON':'Pin etkinleştirildi',
        'MODAL_PIN_OFF':'Pin devre dışı bırakıldı',
        'MODAL_PRECONTROL_ON':'Rastgele doğrulama sorusu etkinleştirildi',
        'MODAL_PRECONTROL_OFF':'Rastgele doğrulama sorusu devre dışı bırakıldı',
        'MODAL_OP14_ON ':' Anket uygulamasındaki talimat kutusunu göster aktif ',
        'MODAL_OP14_OFF ':' Anket uygulamasında talimat kutusunun görüntülenmesi devre dışı bırakıldı ',
        'MODAL_OP15_ON ':' Anket uygulamasında destek panelini göster etkinleştirildi ',
        'MODAL_OP15_OFF ':' Anket uygulamasında destek kutusunu göster devre dışı bırakıldı ',
        'MODAL_OP16_ON ':' Anket uygulamasında kullanıcı adının görüntülenmesi aktiftir ',
        'MODAL_OP16_OFF ':' Anket uygulamasında kullanıcı adının görüntülenmesi devre dışı bırakıldı ',
        'TITUOPTS': 'Seçenekler',
        'TITUCORRS': 'Doğrulanacak e-postalar',
        'SELLANG': 'E-postayı görüntülemek için listeden bir dil seçin',
        'SELLANG_L': 'Bir dil seç',
        'ASUNTO': 'Posta konusu',
        'ASUNTOPILOTO': 'Pilot posta konusu',
        'WAIT':'Değişiklik kaydediliyor',
        'ULTD': 'Sınırsız',
        'CLOUD_LEGACY': 'Dosya yöneticisinin güncellenmiş sürümünü etkinleştir',
        'CUSTOM_TEXT_CERT': 'Çoklu site sertifika metnini etkinleştir',
        'CUSTOM_TEXT_CERT_EDIT': 'Sertifika metnini düzenleyin',
        'TEXT_SECC_CONF_VOIC': 'Ses yapılandırma bölümünü göster',
        'SAVED_CHANGES': 'Değişiklik başarıyla kaydedildi',
        'CUSTOM_TEXT': {
          'TITULO': 'Çoklu site sertifikasının kapsadığı ülkeleri listeleyin',
          'SUBTITULO': 'Yeni metni yaz',
          'SUBTITULO2': 'Uyarı, metni değiştirir ve Tamam düğmesini tıklarsanız, mevcut metnin üzerine yazılacaktır.',
          'HINT': 'Sertifika metni',
          'OK': 'Kabul etmek',
          'CANCEL': 'İptal',
          'SAVED_CHANGES': 'Metin doğru bir şekilde kaydedildi',
          'CURRENT_T1': 'Geçerli çok siteli metin',
          'CURRENT_T2': 'Mevcut çoklu site metni çok uzun, görüntülemek için Düzenle düğmesini tıklayın',
        }
      },
      'ASOCIARCERTIFICAR':{
        'CHECK':'Kültür denetimini bir sertifikayla ilişkilendirin',
        'INPUT':'İlişkilendirilecek sertifika',
        'INPUT_2':'İlişkilendirilecek ürün',
        'CERTIFICAR':'Onaylayın',
        'MEDIR':'Ölçüm',
      },
      'LOG_SENDGRIND':{
        'TITULO':'SendGrid \ ın Günlüğü',
        'OPCION':'Bir seçenek seçin:',
        'TOOLTIP':'Arama durumu',
        'TABLA':{
          'USUARIO':'Kullanıcı',
          'EMAIL':'Eposta',
          'ASUNTO':'Konu',
          'ESTATUS':'Durum'
        },
        'DIALOG_SENDGRIND':{
          'TITTULO':'Posta Bilgileri',
          'TO':'İçin',
          'FROM':'Nereden',
          'SUBJECT':'Konu',
          'HISTORIAL':'Posta Geçmişi',
          'ESTATUS':'Durum',
          'ABIERTO':'Saatler açık:',
          'ULTIMO_EVENTO':'Son olay:',
          'SIN_CORREOS':'E-posta geçmişiniz mevcut değil!',
          'BOTON':'Kapat',
          'NOTE':'NOT: Listede gösterilen tarih saat / saat, yerel saate ayarlanır.',
        },
      },
      'CONFIR_CAMBIOS_SECCION':'Şu anda anket zaten oluşturulmuş,\n\n değişiklikleri yapmak istediğinizden emin misiniz?\n\nOnaylarsanız anketi yeniden oluşturun',
      'MODAL_CAMBIOS_SECCION':'Bölümler güncelleniyor',
      'TIT_MOD_AGRE_ENCU':'Yeni anket süreci',
       'TEX_NAM_SUR':'Anket adı:',
       'TEX_PLA_SUR':'Şablon seçimi',
       'BTN_AGRE_SUR':'Ekle',
       'PLA_TEX_NAM_SUR':'Anket adı:',
       'PLA_TEX_PLA_SUR':'Şablon seçimi',
       'WARNI_NOT_SURV_NOM35':'Anket şu anda oluşturulmadı',
       'MODAL_CREAT_INFRA':'Altyapı oluşturuluyor, lütfen bekleyin',
       'MODAL_ERROR_INFRA':'Altyapı oluşturulurken bir hata oluştu',
    },
    'ALERTS': {
      'OK': 'Tamam',
      'ODSINSERTOK': 'Şirket doğru şekilde kaydedildi',
      'ODSFAILINSERT': 'Kayıt işlemi başarısız oldu, lütfen tekrar deneyin',
      'COLPLETEFORM1': 'Lütfen 1. adımı tamamlayın',
      'COLPLETEFORM2': 'Lütfen 2. adımı tamamlayın',
      'COLPLETEFORM3': 'Lütfen 3. adımı tamamlayın',
      'COLPLETEFORM4': 'Lütfen 4. adımı tamamlayın',
      'COLPLETEFORM5': 'Lütfen 5. adımı tamamlayın',
      'ODSEXIST': 'Şirket zaten sistemde kayıtlı. Bilgi kaydedilmedi',
      'PASSWORD': {
        'LONGITUD': 'Parola en az sekiz karakter uzunluğunda olmalıdır',
        'MINUSCULAS': 'Parola en az bir küçük harf içermelidir',
        'MAYUSCULAS': 'Parola en az bir büyük harf içermelidir',
        'NUMEROS': 'Parola en az bir sayısal karakter içermelidir',
        'ESPCHARS': 'Parola, alfasayısal değil en az bir özel karakter içermelidir',
        'VALIDACION': 'Parola doğrulanırken bir sorun oldu, lütfen parolayı tekrar yazın ve kullanıcıyı yeniden oluşturmayı deneyin'
      }
    },
    'TI_MANAGER': {
      'TITULO': 'IT Yöneticisi',
      'DESCRIPTION': 'Lütfen, anket öncesi hazırlıklar ve teknik detaylarla ilgili bilgilendirmenin gönderileceği IT Yöneticisine ait bilgileri girin.',
      'DATOS': 'Veri',
      'NOMBRE': 'Adı',
      'APELLIDOS': 'Soyadı',
      'EMAIL': 'E-mail',
      'TELEFONO': 'Telefon',
      'EXTENSION': 'Dahili',
      'CELULAR': 'GSM numarası',
    },
    'PERFILES': {
      'CABECERA':{
        'TITULO': 'Profil Oluşturma',
        'DESCRIP': 'Lorem ipsum dolor sit amet, consectetur adipisicing elit,'
      },
      'BOTONES':{
        'BOT1':{
          'TITULO': 'Şirket profili',
          'BOTON': 'Oluştur'
        },
        'BOT2':{
          'TITULO': 'Kullanıcı profili',
          'BOTON': 'Yönetici'
        },
        'BACK': 'Önceki',
        'NEXT': 'Sonraki',
        'RESET': 'Reset',
        'EDIT': 'Kayıt etmek'
      },
      'EMPRESA':{
        'WAIT': 'Bekle...',
        'TITUHEAD': 'Şirket profili',
        'CLOUD': 'Özel klasör',
        'INFO': 'Şirket profili oluşturun',
        'INFOMOD': 'Bu şirketin profil verilerini değiştirebilirsiniz <b>(değişiklikler otomatik olarak kaydedilir)</b>',
        'PDF':{
          'BOTONDESCARGA':'Bilgileri pdf olarak indir',
          'FECHA':'Tarih: ',
          'HORA':'Zaman: ',
          'MODAL':'İndirilecek dosya oluşturuluyor...',
        },

        'ACTUALIZARCA':{
          'ACTUALIZARCA':'Culture Audit Güncelle',
          'ACTUALIZARCA_BRI':'Kültür Özetini Güncelle',
          'ACTUALIZARCA_ACTIAN':'Eylem Planını Güncelleyin',
          'CERRAR':'Kapat',
          'SUCCESS':'Culture Audit başarıyla güncellendi',
          'SUCCESS_ACTION':'Eylem planlayın başarıyla güncellendi',
          'ERROR':'Hata, Culture Audit sertifikalı bir ürünü yok',
          'ERROR_ACTION':'Hata, your Eylem planlayın sertifikalı bir ürünü yok',
        },

        'SECCIONES':{
          'SEC1': {
            'TITULO': 'Şirket Bilgileri',
            'TITULOPDF': 'Şirket Bilgileri ',
            'NOMEMP': 'Şirket adı',
            'NOM': 'Adı',
            'SECTORREQUIRED': 'Sektör seçiniz',
            'SUBSECTORREQUIRED': 'Alt-sektör seçiniz',
            'ANIOFU': 'Kuruluş yılı',
            'SALESFORCE': 'Salesforce ID',
            'CODE': 'Şirket ID',
            'SALES_REQUIRED': 'Salesforce ID gerekiyor',
            'CODE_REQUIRED': 'Şirket ID gerekiyor',
            'INSTITUTO': 'Enstitü',
            'INSTITUTO_REQUIRED': 'Enstitü gerekiyor',

            'COMPANY': 'Şirket Adı',
            'COMPANY_REQUIRED': 'Şirket adı gerekiyor',
            'CAMPO_INVALID': 'Alan şu karakterlere izin vermiyor /*?"<>:\'',
            'COMPANY_ACOR': 'Şirket kısa adı',
             'MOD_INGRE_ACORT': 'Devam etmek için kısa şirket adını girin',
             'ACORT_REQUIRED': 'Şirket kısa adı gerekli',
             'SEDE': 'Ev sahibi ülke',
             'SEDE_REQUIRED': 'Devam etmek için ev sahibi ülkeyi seçmek gerekiyor',
            'PUBLICATION': 'Liste Adı',
            'PUBLICATION_REQUIRED': 'Duyurularda kullanılacak isim',
            'FUNDATION': 'Kuruluş yılı',
            'FUNDATION_REQUIRED': 'Kuruluş yılı gerekiyor',
            'EMP_TC_REQUIRED': 'Tam zamanlı çalışan sayısı gerekiyor',
            'EMP_TP_REQUIRED': 'Part-time çalışan sayısı gerekiyor',
            'TOTCOL_REQUIRED': 'Lütfen toplam katılımcı sayısını girin',
            'RANKING': 'Sıralama',
            'RANKING_REQUIRED': 'Liste yılını seçiniz',
            'TIPO': 'Çalışan aralığı',
            'TIPO_REQUIRED': 'Uluslararası/Ulusal bilgisi gerekiyor',
            'MULTINACIONAL': 'Uluslararası',
            'MULTINACIONAL_REQUIRED': 'Eğer uluslararası şirket ise lütfen seçiniz',
            'ANIORANK_REQUIRED': 'Liste yılı',
            'REGION': 'Bölge',
            'REGION_REQUIRED': 'Bölgenizi seçin',
            'PAIS': 'Ülke',
            'ESTADO': 'Eyalet, şehir veya il',
            'NAM_RANKIN':'Sıralama adı',
             'TYP_RANKIN':'Tür sıralaması',

            'OPTSI': 'Evet',
            'OPTNO': 'Hayır',

            'EMP_TC': 'Tam zamanlı çalışan sayısı',
            'EMP_TP': 'Part-time çalışan sayısı',
            'TOTCOL': 'Çalışan sayısı',
            'ANIORANK': 'Liste yılı',
            'ETIQ_CATALOGOS':{
              'SECTOR': 'Sektör',
              'SUBSECTOR': 'Alt-sektör',
              'MULTIN': 'Uluslararası',
              'TIPO': 'Tip (Sıralama veya sektör)',
              'REGION': 'Lütfen bir bölge seçin'
            },'CATALOGOS':{
              'INSTITUTOS': catalogos.institutos,
              'SECTORES': catalogos.sectores,
              'RANKING': catalogos.ranking,
              'REGIONES': catalogos.regiones,
            }
          },
          'SEC2': {
            'TITULO': 'Cultural GO Sorumlusu',
            'NOM': 'Adı',
            'APE': 'Soyadı',
            'EMAIL': 'E-mail',
            'TEL': 'Telefon',
            'EXT': 'Dahili',
            'CEL': 'GSM No',


            'NOM_REQUIRED': 'İsim giriniz',
            'APE_REQUIRED': 'Soyadınızı giriniz',
            'EMAIL_REQUIRED': 'E-mail giriniz',
            'TEL_REQUIRED': 'Telefon giriniz',
            'EXT_REQUIRED': 'Dahili no giriniz',
            'CEL_REQUIRED': 'GSM giriniz'

          },
          'SEC3': {
            'TITULO': 'İK Direktörü / CHRO',
            'NOM': 'Adı Soyadı',
            'EMAIL': 'E-mail',
            'TEL': 'Telefon',
            'EXT': 'Dahili',
            'CEL': 'GSM No',

            'NOM_REQUIRED': 'İsim giriniz',
            'APE_REQUIRED': 'Soyadınızı giriniz',
            'EMAIL_REQUIRED': 'E-mail giriniz',
            'TEL_REQUIRED': 'Telefon giriniz',
            'EXT_REQUIRED': 'Dahili no giriniz',
            'CEL_REQUIRED': 'GSM giriniz'

          },
          'SEC4': {
            'TITULO': 'IT Sorumlusu',
            'NOM': 'Adı Soyadı',
            'EMAIL': 'E-mail',
            'TEL': 'Telefon',
            'EXT': 'Dahili',
            'CEL': 'GSM No',

            'NOM_REQUIRED': 'İsim giriniz',
            'APE_REQUIRED': 'Soyadınızı giriniz',
            'EMAIL_REQUIRED': 'E-mail giriniz',
            'TEL_REQUIRED': 'Telefon giriniz',
            'EXT_REQUIRED': 'Dahili no giriniz',
            'CEL_REQUIRED': 'GSM giriniz'
          },
          'SEC5': {
            'TITULO': 'Teslim',
            'ENTRE': 'Teslim',
            'TIPO': 'Tip',

            // 'ENTRE_REQUIRED': 'Ingrese el entregable',
          }
        },
        'MENSAJES':{
          'CARGABD': 'Veriyi yükle',
          'STATUS': 'DURUM',
          'CORRECTO': 'Şirket profili başarıyla oluşturuldu',
          'ERROR': 'Şirket profili oluşturulurken bir hata oluştu'
        }
      },
      'USUARIO':{
        'TITULO_LOGIN':'Giriş yapmak istediğiniz kullanıcıyı seçin',
        'MJS_COMPLETE_INFO': 'Lütfen bilgileri doldurunuz. ',
        'MSJ_INVALIDEMAIL': 'Lütfen geçerli eposta adresini giriniz. ',
        'MSJ_SELECTCOMPANY': 'Lütfen bir şirket seçin',
        'REGISTER_SUCCESS': 'Kullanıcı başarıyla oluşturuldu',
        'REGISTER_SUCCESS_SWIFT': 'Kullanıcı başarıyla kayıt oldu, kullanıcınıza aktivasyon için bir e-posta gönderildi',
        'REGISTER_ERROR': 'Hata, kullanıcı kayıt olamadı, lütfen tekrar deneyin',
        'PRODUCT_REGISTEROK': 'Ürün doğru şekilde kaydedildi.',
        'PRODUCT_REGISTERPREVIOUS': 'Ürün önceden kaydedilmiş.',
        'PRODUCT_REGISTERFAIL': 'Ürün kaydedilirken hata oluştu, lütfen tekrar deneyin',
        'CERTIFICAR_EXISTENTE': 'Sertifikalı ürün zaten var',
        'CERTIFICAR_NO_TERMINADO': 'Aşağıdaki ürünü eklemek için yıl sertifikasına karar vermelisiniz',
        'CERTIFICAR_NO_EXISTENTE': 'Pulsecheck Ürününü eklemek için yıl için sertifika almanız gerekir',
        'PULSOS-COMPLETOS':'Şu anda izin verilen bakliyat var',
        'MSJ_SELECTYEAR': 'Liste yılı',
        'MSJ_SELECTPRODUCT': 'Lütfen bir ürün seçiniz',
        'MSJ_SELECTTEMPLETE': 'Anket şablonu seç',
        'MSJ_SELECTEMAILTEMPLETE': 'E-mail şablonu seç',
        'SIN_USUARIO': 'Bu ürünü ekleyebilmek için bu şirketin bir kullanıcı kaydettirmesi gerekiyor',
        //'SIN_SURVEYTOKEN': 'Bu ürünü atamak için ilişkilendirmek üzere anket kodunu girmeniz gerekir',
        'MISMOANIOCERTIFICAR': 'Ürün eklenemiyor, aynı yıla ait bir Certify ürününüz zaten var, farklı bir yıl seçin ve tekrar deneyin',
        'SIN_SURVEYTOKEN': 'Bu ürünün yılı henüz bir ankete sahip değil',
        'SIN_CERTIFICAR_ASOCIA': 'Yine de sertifikalı bir ürünü ilişkilendirmeniz gerekiyor',
        'SIN_TABLEAUVER': 'Bu ürünü atamak için ilişkilendirmek üzere sonuç sürümünü girmeniz gerekir',
        'SINRANKING': 'Devam etmeden önce bu ürün için sıralama yılını seçmelisiniz',
        'SINTIPORANK': 'Devam etmeden önce bu ürün için sıralama türünü seçmelisiniz',
        'SINIDOPORTUNITY': 'Devam etmeden önce bu ürün için fırsat kimliğini girmeniz gerekiyor',
        'SINNAMEOPORTUNITY': 'Devam etmeden önce bu ürün için fırsat adını girmelisiniz',
        'SINIDTYPERESULT': 'Devam etmeden önce bu ürün için sonuç türünü girmeniz gerekiyor',
        'SINPROYECTMANAGER': 'Devam etmeden önce bu ürün için proje yöneticisinin adını girmeniz gerekiyor.',
        'SINCORREOPM': 'Devam etmeden önce bu ürün için proje yöneticisinin e-postasını girmeniz gerekiyor',
        'EMAILNOVALIDO': 'Girilen proje yöneticisinin e-postası geçerli biçimde değil, lütfen kontrol edin ve doğru şekilde yeniden girin',
        'GUARDANDOPRODUCTO': 'Seçilen ürün firmaya ekleniyor, lütfen biraz bekleyiniz.',
        'TOKENMODAL_1': 'Bu, yeni eklenen ürünün anket belirtecidir',
        'TOKENMODAL_2': 'Ne sonraki yapmak istiyorsun?',
        'TOKEN_SI': 'jetonu kopyala',
        'TOKEN_NO': 'Devam et',
        'TOKEN_COPIADO': 'Anket jetonu panoya başarıyla kopyalandı',

        'TITUHEAD': 'Kullanıcı profili',
        'TITUCREARHEAD': 'Kullanıcı oluştur',
        'TITUBUSCARHEAD': 'Kullanıcı ara',
        'TITUBUSCAREMPRESA': 'Şirket ara',
        'TITUUSERGPTWHEAD': 'Yönetici Kullanıcılar',
        'INFO': 'Bir kullanıcının profili',
        'USUARIO': 'Kullanıcı',
        'USE_NAM': 'Kullanıcı Adı',

        'USUARIOREQUIRED': 'Kullanıcı gerekli',
        'USUARIONAMEREQUIRED': 'Kullanıcı adı gerekli',
        'CONTRAREQUIRED': 'Şifre gerekli',
        'LEVELREQUIRED': 'Bir seviye seçin',
        'CONTRA': 'Şifre',
        'COMPANY': 'şirket',
        'NIVEL': 'Yetki seviyesi',
        'NIVELES': catalogos.niveles,
        'GUARDA': 'Kaydet',
        'TH-NOMEMPRE':'Şirket Adı',
        'TH-USUARIO':'Kullanıcı',
        'TH-TUSUARIO':'Kullanıcı tipi',
        'TH-ACCIONES':'Hareketler',
        'TH-LOGIN':'Oturum aç',
        'TH-INSTITUTO':'Enstitü',
        'ACC-DELET':'Kullanıcıyı sil',
        'ACC-EDIT':'kullanıcıyı düzenle',
        'UPDATE-USER':'Doğru güncellendi',
        'EXIST-USER':'Mevcut kullanıcı',
        'ALERT-EDIT':'Kullanıcıyı değiştireceğinizden emin misiniz?',
        'USUARIO-T':'Kullanıcılar',
        'CONFIRM_ELIMINAR_USU':'Kullanıcıyı silmek istediğinizden emin misiniz?',
        'INGR_ELIMINAR_USU':'<span>Metin alanına kırmızıyla işaretlenmiş kullanıcıyı girin ',
        'INGR_ELIMINAR_USU.2':'</span>',
        'ERROR_ELIMINAR_USU':'Girilen kullanıcı eşleşmiyor',
        'OK_ELIMINAR_USU':'Kullanıcı doğru şekilde silindi',
        'PASSWORDSAFE': 'Şifre en az 8 karakter uzunluğunda olmalıdır: en az 1 rakam, en az 1 küçük harf, en az 1 BÜYÜK HARF ve en az 1 alfasayısal olmayan karakter',
        'PRODUCT_EXIST':'Seçilen tarihe sahip ürün zaten mevcut',
        'WAR_ADD_NA_US':'Lütfen kullanıcı adını girin',
         'WAR_ADD_TOT_US':'Lütfen toplam ortak çalışan sayısını girin',
         'WAR_ADD_EMA_US':'Lütfen kullanıcı e-posta adresini girin',
         'WAR_ADD_PASS_US':'Lütfen kullanıcı şifresini girin',
         'WAR_INCO_EMA_US':'Girilen e-posta yanlış',
         'WAR_INCO_PASS_US':'Parola izin verilen biçimde değil',
         'MOD_SAV_US':'Kullanıcı kaydediliyor',
        'MENSAJES':{
          'CARGABD': 'Veriyi yükle',
          'STATUS': 'DURUM',
          'CORRECTO': 'Kullanıcı başarıyla oluşturuldu',
          'ERROR': 'Kullanıcı profili oluşturulurken bir hata oluştu'
        }
      }
    },
    'CONSULTARENCUESTA':{
      'TITULO': 'Ankete danışın',
      'HEADER': 'Enstitüsü seçin',
      'INSTITUTOS': 'enstitüleri',
      'FILTRO': 'filtre',
      'FILTRO_EMPRESA':'Şirketi filtrele',
      'FILTRO_TI_EMPR_TOKEN':'Jeton anketini / şirket türünü filtreleyin',
      'SELECCIONFILTRO': 'Gerekli bilgileri arayın',
      'BOTON_DESCARGA_EXCEL': 'Excel formatında bilgi indirme',

      'CARGANDO': 'Yükleme bilgileri...',
      'NOMBRE_DE_EMPRESA': 'Şirketin adı',
      'TIPO_DE_EMPRESA':'Şirket türü',
      'FECHA_C': 'Yaratılış tarihi',
      'SECTOR': 'sektör',
      'SUBSECTOR': 'Alt sektör',
      'TIPO_ENC': 'Anket türü',
      'PLANTILLA': 'şablon',
      'CATALOGOSPRODUCTOS': catalogos.plantillas,
      'TOKEN': 'Survey token',
      'ID_ENC': 'Anket Kimliği',
      'ANIO': 'Yıl',
      'CORREOS_EN': 'Mail gönderildi',
      'FECHA_A': 'Uygulama tarihi',
      'FECHA_CR': 'Kapanış tarihi',

      'MODAL_SUCCES': 'Dosya doğru indirildi',
      'MODAL_WARNING': 'Hiçbir kurum seçilmedi',
      'VIZUENCU':'Anketleri görüntüleme',
      'SELE_AN_ENCU':'Seleccione un año',
    },
    'CONSULTAR_RT':{
      'TITULO':'Teknik gereksinimlere danışın',
      'HEADER': 'Enstitüsü seçin',
      'INSTITUTOS': 'Enstitüler',
      'FILTRO': 'Filtrele',
      'SELECCIONFILTRO':'Gerekli şirketi arayın',
      'CARGANDO':'Yükleme bilgileri...',
      'NOMBRE_DE_EMPRESA':'Şirket Adı',
      'FECHA_DE_EMPRESA':'Tarih oluşturuldu',
      'PRODUCTO':'ürün tipi',
      'TOKEN': 'Anket jetonu',
       'ESTATUS': 'Durum',
       '0': 'Başlamadı',
       '1': 'İşlemde',
       '2': 'Bitti',
      'ACCIONES':'Hareketler',
      'PRODUCTOS':catalogos.productos,
      'ELEMENTOS':'Sayfa başına öğeler',
      'DE':'nın-nin',
      'SIGUIENTE':'Sonraki',
      'ULTIMA':'Son Sayfa',
      'PRIMERA':'İlk sayfa',
      'ANTERIOR':'Önceki'

    },
    'AUDITORIA-AUTOMATICA':{
      'TITULO': 'Otomatik Denetim',
      'TABLA':{
        'TH-NOM-EMPRESA':'Şirket Adı',
        'TH-NO-COLAB':'Hayır. Ortak çalışanlar',
        'TH-CONTESTADOS':'Yanıtlanan',
        'TH-FALTANTES':'Eksik',
        'TH-PROGRESO':'İlerleme',
        'TH-ACCIONES':'Hareketler',
        'MSJ-DETALLES':'Ayrıntılara bakınız',
      }

    },
    'RESULTA-AUDITO':{
      'TIEM-RES-TAB':'Ortak çalışanların yanıt verme süresi',
      'RES-CONT-TAB':'Kontrol Yanıtları',
      'RES-COMENT-TAB':'Yorum yanıtları',
      'TIEM-RES-TITULO':'Ortak çalışanların yanıt süresini kontrol edin',
      'RES-CONT-TITULO':'Kontrol sorularına verilen cevapların yüzdesi',
      'RES-COMENT-TITULO':'Boş, tekrarlanan veya tekrarlanan karakterler içeren yorumların yüzdesi',
      'RES-AGREGAR': 'Örnek ekleniyor',
      'RES-SELECCIONAR': 'Örnek seçin',
      'RES-TEXTO1': 'Henüz örnek oluşturulmadı',
      'RES-TEXTO2': 'Verileri görüntülemek için lütfen bir örnek seçin',
      'INGRE-NOM': 'Numunenin adını girin',
      'SELEC-REG ':' Örneklemin kurallarını seçin ',
      'REGLAS':{
        '1':' 10 dakikadan daha kısa sürede cevap veren ortak çalışanlar ',
        '2':' Tüm maddelerine 5 değeri ile cevap veren ortak çalışanlar ',
        '3':'Kontrol sorusuna EVET yanıtı veren işbirlikçiler',
        '4':' Rastgele bir soruyu yanlış cevaplayan ortak çalışanlar ',
        '5':' 10 dan fazla yanıtı değiştiren işbirlikçiler ',
      },

      'TABLA':{
        'TITULO': 'Örnekteki ortak çalışanların verileri',
        'NOMBRE': 'Ad',
        'TELEFONO': 'Telefon',
        'CELULAR': 'Hücresel',
        'CORREO': 'E-posta adresi',
        'COMENTARIO': 'Yorum',
      },
      'MODALES':{
        'GENERANDO': 'Örnek oluşturuluyor, lütfen bekleyin ...',
        'GUARDANDO': 'Yorum kaydediliyor, lütfen bekleyin ...',
        'TITULO': 'Kaydedilmiş yorum',
        'CERRAR': 'Kapat',
        'TITULO_INFORMACION': 'Yorumu ekledikten sonra alan boş kalamaz, içine kaydedilen son veriler alınacaktır',
        'SUCCE-MUES': 'Örnek doğru şekilde oluşturuldu',
        'WARNI-SINU': 'Kaydolacak başka kullanıcı kalmadı',
        'WARNI-CONDI': 'Bir isim koymayı ve en az bir kural seçmeyi unutmayın',


      },
    },
    'DESCARGAR_ENCUESTA':{
      'NPS':'NPS',
      'REACTIVOS':'tablolar',
      'CONTROL':'Kontrol',
      'DEMOGRAFICOS':'Demografik',
      'ABIERTAS':'Açık',
      'CA':'4ALL',
      'CODIGOPROYECTO':'Proje kodu: ',
      'ANIOAPLICACION':'Uygulama yılı: ',
      'MENSAJE':'Anketi indirmek mümkün değil, çünkü henüz oluşturulmadı',
      'ACEPTAR':'Kabul etmek',
      'TEXTODESCARGA':'Anket ',
      'DESCARGARENCUESTA':'Anketi indir',
      'INFORMACIONYAVISO':'Anket Bilgileri ve Gizlilik Bildirimi',
      'SECCIONES':'Bölümler',
      'MODAL':{
        'TITLE':'Dil listesi',
        'SUBTITLE':'Bir dil seç',
        'PLACEHOLDER':'Yok',
        'BTNCLOSE':'Kapatmak',
        'BTNSELECT':'Kabul etmek'
      }
    },
    'INFORT': {
      'TITULO': 'Teknik gereksinimler ilerleme',
      'SINLANGS': 'Adımların listesini görmek için bu üründeki dilleri seçmeniz gerekir',
      'PASOS': {
        'PASO_1': 'Adım listesi',
        'PASO_2': 'Anket',
        'PASO_3': 'Kayıt'
      },
      'LISTAPASOS': {
        'autentication': 'Anket kimlik doğrulaması',
        'testAccess': 'Ekran testi',
        'testEmail': 'E-posta alımının kanıtı',
        'validationQ': 'Doğrulama anketi',
        'requirements': 'Veri gizliliği politikası',
      },
      'STATUS': {
        'PEND': 'Bekliyor',
        'DONE': 'Adım tamamlandı',
      },
      'RESP': 'Yanıt gönderildi',
      'NORESP': 'Cevapsız'
    },
    'MODAL_CONSULT_INFRAESTRU':{
      'TITL':'Özel altyapı:',
      'INSTRUC_1':'Özel altyapı eklemek istiyor musunuz?',
      'LAB_SUBDOMINIO':'SubDomain',
      'WARN_CARACT':'Alan ñ harfine, büyük harflere ve özel karakterlere izin vermiyor',
      'BTN_CONTI':'Devam',
      'SI':'Evet',
      'NO':'Hayır',
      'MODA_IMPORT_SUBDOM':'Devam etmek için alt alan adını girmelisiniz',
    }
  }
};
